// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-user[data-v-6859826d] {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n}\n.icon-user--large[data-v-6859826d] {\n  width: 140px;\n  height: 140px;\n}\n.icon-user--xlarge[data-v-6859826d] {\n  width: 180px;\n  height: 180px;\n}\n", ""]);
// Exports
module.exports = exports;
